export default "__VITE_ASSET__5a82d553__"